module.exports = __webpack_public_path__ + "media/images/pages/icn_balloon_number_orange_08-ef70b6bff04a1c2bf540c327667ce913.svg";